import React from 'react';
import './About.css';

export default function AboutUs() {
  return (
    <div className="about-us">
      <h1>About Us</h1>
      
      <p>
        Welcome to <strong>Markt</strong>, the premier online marketplace for the <strong>Scaler School of Technology</strong> community. At our tech-focused campus, we recognize the importance of making connections, which is why Markt is designed to offer a seamless, trusted environment for buying and selling products.
      </p>
      
      <h2>Who We Are</h2>
      <p>
        We are <strong>Rohith and Thrishal</strong>, two students from Scaler School of Technology, who built Markt to create a smart, efficient marketplace tailored to the needs of our community. Markt allows users to post products they want to sell, which are then reviewed and approved by our admin team before being displayed in the marketplace feed.
      </p>
      
      <h2>What We Offer</h2>
      <ul>
        <li><strong>Post & Sell:</strong> Whether it's the latest gadget, textbooks, or dorm essentials, you can post your products on Markt. After admin approval, your items will be available for others to discover.</li>
        <li><strong>Browse & Connect:</strong> Explore a curated feed of products ranging from electronics and textbooks to software tools and more. When you find something you like, you can connect directly with the seller to make the purchase.</li>
        <li><strong>Secure Listings:</strong> Our admin approval process ensures that all listings meet our standards, providing a safe and reliable marketplace environment.</li>
      </ul>
      
      <h2>Why Choose Markt?</h2>
      <p>
        <strong>Tech-Focused:</strong> As a marketplace built by and for the tech community of Scaler, we understand the high standards and specific needs of our users.
        <br/>
        <strong>Curated Listings:</strong> Every product undergoes an approval process by our admin team to ensure quality and relevance.
        <br/>
        <strong>User-Friendly:</strong> Our platform is designed for ease of use, making it simple for tech enthusiasts to post, browse, and connect with potential buyers or sellers.
      </p>
      
      <h2>Our Vision</h2>
      <p>
        At <strong>Markt</strong>, we aim to be the trusted marketplace where the tech-minded students of Scaler School of Technology can connect, buy, and sell with confidence. Our mission is to support our community by providing a reliable platform that aligns with the high standards of our tech-focused campus.
      </p>
      
      <h2>Get Involved</h2>
      <p>
        Ready to connect with the Scaler tech community? Join <strong>Markt</strong> today! Whether you're selling your old tech gear or looking for a great deal, Markt is here to help. Have questions or feedback? We’d love to hear from you! Reach out at [contact email] or connect with us on social media.
      </p>
      
      <p className="closing">
        Thank you for choosing Markt, where Scaler’s tech community connects and thrives!
      </p>
    </div>
  );
}
